import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import PageHero from '../components/PageHero';
import Projects from '../components/Projects';

const pageVariants = {
  initial: { opacity: 0, x: 40 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -40 },
};

const ProjectsPage = () => (
  <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{ duration: 0.35 }}>
    <PageHero
      title="Key"
      highlight="Projects"
      subtitle="A selection of SQA and automation projects across AI, healthcare, e-commerce, CRM, and blockchain platforms."
      pattern="dots"
    />
    <Projects hideTitle />
    {/* CTA */}
    <section className="section-padding bg-white dark:bg-dark-100 transition-colors duration-300">
      <div className="container-custom text-center">
        <p className="text-secondary-600 dark:text-gray-100 mb-4">Interested in working together on your next project?</p>
        <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors">
          Get In Touch <FiArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  </motion.div>
);

export default ProjectsPage;
